import moment from 'moment/moment';

export const normalizeStringList = (arr) => {
  return arr
    .map(item => item.trim())
    .filter(Boolean)
    .filter((name, index, array) => array.indexOf(name) === index)
    .sort((a, b) => a.localeCompare(b));
}

export const formatRangeToRequestDates = (dateRange) => {
  if (!dateRange?.selection1) return { startDate: null, endDate: null };

  const start = moment(dateRange.selection1.startDate).locale('en').format('YYYY-MM-DD');
  const end   = moment(dateRange.selection1.endDate).locale('en').format('YYYY-MM-DD');
  return { startDate: start, endDate: end };
};